import { render } from "./ValidationDevisPage.vue?vue&type=template&id=82047b6e&scoped=true&ts=true"
import script from "./ValidationDevisPage.vue?vue&type=script&lang=ts"
export * from "./ValidationDevisPage.vue?vue&type=script&lang=ts"

import "./ValidationDevisPage.vue?vue&type=style&index=0&id=82047b6e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82047b6e"]])

export default __exports__